import { Entity, Item } from '../dictionary-service/generic';
import { Profile } from './profile-response';

export namespace RobotaUa {
  enum Folder {
    All = 'All',
    Sended = 'Sended',
    Selected = 'Selected',
    Invited = 'Invited',
    Refused = 'Refused',
    SavedCvDb = 'SavedCvDb',
    Deleted = 'Deleted',
    New = 'New',
    BlackList = 'BlackList',
    AllNotRead = 'AllNotRead',
    AllRead = 'AllRead',
    ReadSent = 'ReadSent',
    JobOffer = 'JobOffer',
    Hired = 'Hired',
  }

  enum Currency {
    Ua = 'Ua',
    Usd = 'Usd',
  }

  export enum ResumeSource {
    None = 'None',
    AttachedFile = 'AttachedFile',
    Notepad = 'Notepad',
    Selected = 'Selected',
    NoCvApply = 'NoCvApply',
    Interaction = 'Interaction',
    VacancyOffered = 'VacancyOffered',
    Recommended = 'Recommended',
  }

  export enum SocialLinkType {
    Skype = 'Skype',
    Facebook = 'Facebook',
    LinkedIn = 'LinkedIn',
    Twitter = 'Twitter',
    GooglePlus = 'GooglePlus',
    Vk = 'Vk',
    Ok = 'Ok',
    Portfolio = 'Portfolio',
    Telegram = 'Telegram',
    Viber = 'Viber',
    Instagram = 'Instagram',
    Behance = 'Behance',
    Dribbble = 'Dribbble',
    DeviantArt = 'DeviantArt',
    ArtStation = 'ArtStation',
    GitHub = 'GitHub',
  }

  enum Gender {
    Unknown = 'Unknown',
    Male = 'Male',
    Female = 'Female',
    Other = 'Other',
  }

  export enum ApplicationStatus {
    New = 1,
    Viewed = 2,
    Interesting = 3,
    LongList = 4,
    NotInteresting = 5,
    Invited = 6,
    Refused = 7,
    Hired = 10,
    Archive = 11,
  }

  export enum ApplicationSource {
    Application = 'Application',
    ApplicationWithResume = 'ApplicationWithResume',
    ApplicationWithFile = 'ApplicationWithFile',
    SelectedResume = 'SelectedResume',
    VacancyInteraction = 'VacancyInteraction',
    Recommended = 'Recommended',
    VacancyOffered = 'VacancyOffered',
  }

  interface AdditionalData {
    id: number;
    name: string;
    description: string;
  }

  interface Contact {
    value: string | null;
    isConfirmed: boolean;
  }

  interface SocialLink {
    value: string | null;
    type: SocialLinkType;
  }

  interface ApplyContacts {
    emails: Contact[] | null;
    phones: Contact[] | null;
    socials: SocialLink[] | null;
  }

  interface CvRecommendation {
    id: number;
    name: string | null;
    position: string | null;
    companyName: string | null;
    eMail: string | null;
    phone: string | null;
    readyToGiveAtRequest: boolean;
  }

  interface Experience {
    id: number;
    position: string | null;
    company: string | null;
    branchId: number;
    description: string | null;
    notebookCompanyId: number;
    period: string | null;
    startWork: string | null;
    endWork: string | null;
    companySite: string | null;
    recommendation: CvRecommendation[];
  }

  interface Education {
    title: string | null;
    speciality: string | null;
    yearOfGraduation: number | null;
    location: string | null;
  }

  export interface Application {
    addDate: string;
    additionalsEducations: Education[] | null;
    birthDate: string | null;
    blackListDate: string;
    cityId: number;
    contacts: ApplyContacts;
    coveringLetterExists: boolean;
    coveringLetterName: string | null;
    currencyId: Currency;
    deleteDate: string;
    education?: Education[];
    email: string | null;
    eMail: string | null;
    experience?: Experience[];
    fileName: string | null;
    filePath: string | null;
    folderId: Folder;
    gender: Gender;
    id: number;
    interestingDate: string;
    interviewDate: string;
    invitationDate: string;
    isAnonymous: boolean;
    isApproved: boolean;
    isArchive: boolean;
    isControlQuestionExist: boolean;
    isFromCVDB: boolean;
    isHaveNoExperience: boolean;
    isInBlackList: boolean;
    isInteresting: boolean;
    isInvited: boolean;
    isLetterReviewUnsubscribe: boolean;
    isMatchVacancy: boolean;
    isMessageSent: boolean;
    isOpenContact: boolean;
    isOpenResumeContactInfo: boolean;
    isRead: boolean;
    isRefused: boolean;
    isRegistred: boolean;
    isRepeated: boolean;
    isSuperCandidate: boolean;
    language: number;
    name: string | null;
    notebookId: number;
    notesCount: number;
    number: number;
    originalVacancyId: number;
    parentId: number;
    phone: string | null;
    photo: string | null;
    refuseDate: string;
    resumeId: number;
    resumeType: ResumeSource;
    salary: number;
    seekerNotebookId: number;
    skillsSummary: string | null;
    speciality: string | null;
    summaryPercentage: number;
    tagId: Folder;
    vacancyId: number;
    resumeFile: {
      summary: string | null;
    };
  }

  interface ResumeContact {
    id: number;
    typeId: string;
    subTypeId: string;
    description: string | null;
  }

  export interface Resume {
    activeLevel:
      | 'None'
      | 'Public'
      | 'OnlyForVerifiedEmployer'
      | 'ExceptEmployers'
      | 'StrongDefinedEmployer'
      | 'Hide'
      | 'MegaEmployer';
    addDate: string;
    additionals: AdditionalData[] | null;
    age: string | null;
    aspnet_UserUIN: string;
    birthDate: string;
    blockingReasonIds: string | null;
    branchIds: string | null;
    cityId: number;
    contacts: ResumeContact[] | null;
    contactsOpenedByMe: boolean;
    contactsOpenedBySystem: boolean;
    currencyId: number;
    currencySign: string | null;
    customBlockingReason26_Text: string | null;
    diiaCertificate: string | null;
    districtIds: number[] | null;
    educationId: number;
    educations: unknown[] | null;
    email: string | null;
    experiences: Experience[] | null;
    fatherName: string | null;
    fillingPercentage: number | null;
    fillingType: number | null;
    hasDislike: boolean;
    hasHiddenPhones: boolean;
    hasOwnCar: boolean;
    hasPhone: boolean;
    isAnonymous: boolean;
    isConfirmed: boolean;
    isDisabled: boolean;
    isFromCvDb: boolean;
    isHasTextPartition: boolean;
    isInBlackList: boolean;
    isOnline: boolean;
    isOpenResumeInfo: boolean;
    isPhoneConfirmed: boolean;
    isSelectedToNotepad: boolean;
    isStudent: boolean;
    isViewed: boolean;
    language: 'None' | 'Russian' | 'English' | 'Ukrainian';
    languageSkills: unknown[] | null;
    lastActivityDate: string | null;
    lastViewDate: string;
    link: string | null;
    name: string | null;
    notebookId: number;
    notebookIds: string | null;
    offerDate: string;
    offerPerson: string | null;
    openContact_MultiUserId: number;
    openContact_MultiUserName: string | null;
    openContact_ViewDate: string;
    phone: string | null;
    photo: string | null;
    profLevelId: number;
    relocations: { cityId: number }[] | null;
    resumeId: number;
    salary: string | null;
    salaryFull: string | null;
    scheduleId: number;
    scheduleIds: string | null;
    searchState: 'None' | 'Active' | 'NowWorking';
    seoTags: unknown[] | null;
    serviceExists: boolean;
    sex: number;
    showResumeInfo: boolean;
    skills: unknown[] | null;
    skype: string | null;
    speciality: string | null;
    stateMode: 'UnCreated' | 'Active' | 'Hide' | 'Deleted';
    subRubrics: unknown[] | null;
    surname: string | null;
    updateDate: string | null;
    vacancyLinks: unknown[] | null;
  }

  export namespace GraphQL {
    export enum CandidatesTypes {
      'APPLICATION' = 'APPLICATION',
      'APPLICATION_WITH_RESUME' = 'APPLICATION_WITH_RESUME',
      'APPLICATION_WITH_FILE' = 'APPLICATION_WITH_FILE',
      'SELECTED_RESUME' = 'SELECTED_RESUME',
      'VACANCY_INTERACTION' = 'VACANCY_INTERACTION',
      'RECOMMENDED' = 'RECOMMENDED',
      'VACANCY_OFFERED' = 'VACANCY_OFFERED',
      'ACCRUED' = 'ACCRUED',
    }

    export interface Contact {
      value: string;
      confirmed: boolean;
    }

    export interface Salary {
      amount: number;
      currency: string;
    }

    export interface Position {
      title: string | null;
      salary: Salary | null;
    }

    export interface SocialLink {
      value: string;
      type: string;
    }

    export interface Contacts {
      phones: Contact[];
      emails: Contact[];
      socials: SocialLink[];
    }

    export interface Experience {
      position: string | null;
      companyTitle: string | null;
      begin: string | null;
      end: string | null;
      description: string | null;
    }

    export interface Name {
      firstName: string;
      lastName: string;
      fatherName: string;
    }

    export interface ResumeAttached {
      contacts: Contacts;
      downloadFileUrl: string;
      downloadFileName: string;
      fullName: string;
      photoUrl: string | null;
    }

    export interface ResumeEmpty {
      contacts: Contacts;
      fullName: string;
      photoUrl: string | null;
    }

    export interface ResumeNotepad {
      age: number | null;
      areContactsOpened: boolean;
      birthdate: string | null;
      city: Item;
      contacts: Contacts;
      desiredPosition: Position;
      experiences: Experience[];
      filling: { percent: number; type: { id: string } } | null;
      fullName: string;
      id: string;
      infos: unknown[];
      name: Name;
      pdfFileName: string;
      photoUrl: string;
      relevanceScore: { value: number; isCalculated: boolean } | null;
      skillsSummary: string | null;
      sortDate: string;
    }

    export interface CvDbResumeFile {
      data: string;
      summary: string;
    }

    export type Resume = ResumeAttached | ResumeEmpty | ResumeNotepad;

    export interface CvDbResume {
      id: string;
      addedAt: string;
      additionals: Item & { description: string }[];
      city: Item;
      contacts: {
        contacts: Partial<{
          email: string;
          phone: Contact;
          socials: SocialLink[];
        }>;
      };
      experiences: Experience[];
      file: {
        data: string;
        summary: string;
      } | null;
      pdf: {
        dataUrl: string;
      };
      personal: Name & { birthdate: string | null; photoUrl: string | null };
      salary: Salary | null;
      title: string;
      updatedAt: string;
    }

    export interface Apply {
      id: string;
      madeAt: string;
      source: string;
      status: Item | null;
      resume: Resume;
      notes: unknown[];
      vacancy: Entity | null;
      user: {
        seekerDetails:
          | (Item & { surname: string | null; fatherName: string | null })
          | null;
      };
    }
  }
}

export namespace SocialPage {
  export interface ParsingRequest {
    readonly text: string;
    readonly source: string;
    readonly url: string;
    readonly profileId: number | null;
  }

  export interface Salary {
    readonly amount: number;
    readonly currency: string;
  }

  export interface Base {
    readonly firstName: string;
    readonly lastName: string | null;
    readonly middleName: string | null;
    readonly contacts: {
      readonly emails: string[];
      readonly phones: string[];
      readonly telegrams: string[];
      readonly socialLinks: string[];
    };
  }

  export interface Details extends Base {
    readonly birthDate: string | null;
    readonly city: string | null;
    readonly image: string | null;
    readonly salary: Salary | null;
    readonly skills: string[];
    readonly speciality: string | null;
    readonly summary: string | null;
  }
}

export interface Experience {
  readonly position: string | null;
  readonly company: string | null;
  readonly startWork: string | null;
  readonly endWork: string | null;
  readonly description: string | null;
}

export interface ExternalProfile extends Profile {
  readonly internalCandidate: {
    id: number;
    name: string;
    statusId: number | null;
  } | null;
  readonly externalId: string;
  readonly externalSource: string;
  readonly externalUrl: string;
  readonly externalApplicationId: string;
  readonly desiredPosition: string | null;
  readonly experiences: Experience[];
  readonly relevanceScore: number | null;
  readonly fillingPercent: number | null;
  readonly hasCV: boolean;
}

export enum CandidateStatus {
  Marked = 'Marked',
  Rejected = 'Rejected',
  Archived = 'Archived',
  Shortlisted = 'Shortlisted',
  Hired = 'Hired',
}

export interface ChangeCandidateStatusPayload {
  readonly applicationId: string;
  readonly status: CandidateStatus;
}
